export default [
  {
    image: { src: 'https://satyr.dev/1120x700/1', alt: 'Primary title' },
    primaryTitle: 'Maecenas ipsum velit',
    secondaryTitle: 'Et harum quidem rerum facilis est et expedita distinctio',
    category: 'Category type',
    type: 'Private sales',
    thumbnail: true,
    cta: { href: 'https://christies.com' },
  },
  {
    image: { src: 'https://satyr.dev/1120x700/2', alt: 'Primary title' },
    primaryTitle: 'Duis sapien nunc',
    secondaryTitle: 'Phasellus et lorem id felis nonummy placerat',
    category: 'Category type',
    type: 'Interview',
    thumbnail: true,
    cta: { href: 'https://christies.com' },
  },
  {
    image: { src: 'https://satyr.dev/1120x700/3', alt: 'Primary title' },
    primaryTitle: 'Aliquam in lorem sit amet leo accumsan lacinia',
    secondaryTitle:
      'Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur',
    category: 'Category type',
    type: 'Collecting guide',
    thumbnail: true,
    cta: { href: 'https://christies.com' },
  },
  {
    image: { src: 'https://satyr.dev/1120x700/4', alt: 'Primary title' },
    primaryTitle: 'Cum sociis natoque penatibus et magnis',
    secondaryTitle: 'Donec odio tempus molestie porttitor ut iaculis quis sem',
    category: 'Category type',
    type: 'Exhibitions & events',
    thumbnail: true,
    cta: { href: 'https://christies.com' },
  },
  {
    image: { src: 'https://satyr.dev/1120x700/5', alt: 'Primary title' },
    primaryTitle: 'Maecenas ipsum velitr',
    secondaryTitle: 'Et harum quidem rerum facilis est et expedita distinctio',
    category: 'Category type',
    type: 'Private sales',
    thumbnail: true,
    cta: { href: 'https://christies.com' },
  },
  {
    image: { src: 'https://satyr.dev/1120x700/6', alt: 'Primary title' },
    primaryTitle: 'Duis sapien nuncir',
    secondaryTitle: 'Phasellus et lorem id felis nonummy placerat',
    category: 'Category type',
    type: 'Interview',
    thumbnail: true,
    cta: { href: 'https://christies.com' },
  },
  {
    image: { src: 'https://satyr.dev/1120x700/7', alt: 'Primary title' },
    primaryTitle: 'Aliquam in lorem sit amet leo accumsan laciniare',
    secondaryTitle:
      'Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur',
    type: 'Collecting guide',
    thumbnail: true,
    cta: { href: 'https://christies.com' },
  },
  {
    image: { src: 'https://satyr.dev/1120x700/8', alt: 'Primary title' },
    primaryTitle: 'Cum sociis natoque penatibus et magniser',
    secondaryTitle: 'Donec odio tempus molestie porttitor ut iaculis quis sem',
    category: 'Category type',
    type: 'Exhibitions & events',
    thumbnail: true,
    cta: { href: 'https://christies.com' },
  },
]
